export default __webpack_public_path__ + "static/media/gesundheitsmanagement.601187af.svg";